import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import sha256 from "@/utilities/sha256";

/**
 * The hash of the database name, which is what a licence is compared against.
 *
 * Held in the query cache rather than worked out per page: it depends on nothing but the database
 * the reader is signed in to, and the launcher asks the same question for twenty pages at once.
 */
export function useDatabaseHash() {
  const { database, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["databaseHash", activeSessionId, database],
    queryFn: () => sha256(database),
    enabled: !!database,
    // The name of the database does not change while the page is open.
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
}
